import { SvgIconType } from './svg.interface';

const Project: SvgIconType = ({
  width = 32,
  height = 32,
  className = '',
  color = '#3AA5DC'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="6" fill={color} />
    <path
      d="M23.8 12.3007L17.173 14.8381L19.0102 7.99902C21.2051 8.58562 22.9857 10.1848 23.8 12.3007Z"
      fill="white"
    />
    <path
      d="M22.1568 18.7495C22.4815 17.5409 22.4782 16.2724 22.1537 15.0727L17.8882 16.7058C16.3622 17.2901 14.8176 15.8972 15.2415 14.3192L16.4219 9.92506C12.8721 9.35409 9.39445 11.5451 8.44365 15.0844C7.42898 18.8615 9.67623 22.7439 13.463 23.756C17.2498 24.7681 21.1422 22.5266 22.1568 18.7495Z"
      fill="white"
    />
    <path
      d="M23.8 12.3007L17.173 14.8381L19.0102 7.99902C21.2051 8.58562 22.9857 10.1848 23.8 12.3007Z"
      fill="white"
    />
    <path
      d="M22.1568 18.7495C22.4815 17.5409 22.4782 16.2724 22.1537 15.0727L17.8882 16.7058C16.3622 17.2901 14.8176 15.8972 15.2415 14.3192L16.4219 9.92506C12.8721 9.35409 9.39445 11.5451 8.44365 15.0844C7.42898 18.8615 9.67623 22.7439 13.463 23.756C17.2498 24.7681 21.1422 22.5266 22.1568 18.7495Z"
      fill="white"
    />
  </svg>
);

export default Project;
